import { RouteInterface } from "../types";
import {
  HOME_PAGE,
  ORGANIZATIONS_PAGE,
  VOUCHERS_EDIT_PAGE,
} from "../util/constants";

export const protectedRoutes: RouteInterface[] = [
  {
    path: VOUCHERS_EDIT_PAGE,
    end: true,
    component: "vouchersEditPage",
  },
  {
    path: `${VOUCHERS_EDIT_PAGE}/:id`,
    end: true,
    component: "vouchersEditPage",
  },
  {
    path: HOME_PAGE,
    end: true,
    component: "vouchersPage/vouchersListPage",
  },
  {
    path: `${ORGANIZATIONS_PAGE}`,
    pages: [
      {
        index: true,
        srcPath: "organizationPages",
        component: "organizationsListPage",
      },
      {
        path: ":organizationId",
        srcPath: "organizationPages",
        component: "organizationPage",
      },
    ],
  },
  // {
  //     path: '/organizations/:organizationId',
  //     exact: true,
  //     component: 'organizationPage',
  // },
  // {
  //     path: '/settings',
  //     exact: true,
  //     component: 'settingsPage',
  // }
];
